import { useState } from 'react';
import { ManualChange } from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/core/ManualChange';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { config } from '../../../../../../config';
import { arrearsFileManualChangesApi } from 'Feature/Arrears/components/ArrearsErrorRecord/ManualChanges/api/ArrearsFileManualChangesApi';

export const useManualChanges = () => {
  const authenticationContext = useAuthenticationContext();
  const api = arrearsFileManualChangesApi(
    authenticationContext,
    config.arrearsFilesApi.urls.arrearsFile!
  );

  const [manualChanges, setManualChanges] = useState<ManualChange[]>([]);
  const [loadingManualChanges, setLoadingManualChanges] = useState<boolean>(false);

  const fetchManualChanges = async (arrearsFileId: string) => {
    setLoadingManualChanges(true);
    const result = await api.get(arrearsFileId);
    if (result.isFailure) {
      setManualChanges([]);
    } else {
      setManualChanges(result.value);
    }
    setLoadingManualChanges(false);
  };

  return {
    manualChanges,
    loadingManualChanges,
    fetchManualChanges
  };
};
